export default __webpack_public_path__ + "static/media/num-05.4d779984.svg";